import ImageCompressor from 'compressorjs';

export const compressImage = async (file) => {
  const maxSize = 1000;
  return new Promise((resolve, reject) => {
    new ImageCompressor(file,{
      quality: 0.8,
      maxWidth: maxSize,
      maxHeight: maxSize,
      success: resolve,
      error: reject
    })
  });
};


// WEBPACK FOOTER //
// src/utils/compressImage.js